import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BreadcrumbComponent} from './breadcrumb.component';
import {AngularSvgIconModule} from "angular-svg-icon";
import {RouterModule} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {LocalizeRouterModule} from "@gilsdav/ngx-translate-router";

@NgModule({
  declarations: [
    BreadcrumbComponent
  ],
    imports: [
        CommonModule,
        AngularSvgIconModule,
        RouterModule,
        TranslateModule,
        LocalizeRouterModule
    ],
  exports: [
    BreadcrumbComponent,
  ]
})
export class BreadcrumbModule { }
